import { createClientConfig } from "@repo/design-system/lib/client-registry";
import FilterbarEonSverige from "~/components/job-board/subclients/sverige/filterbar-eon-sverige";
import HeaderImageJobboardEonSverige from "~/components/job-board/subclients/sverige/headerimage-jobboard-eon-sverige";
import { JoblistEonSverige } from "~/components/job-board/subclients/sverige/joblist-eon-sverige";
import TeaserBarEonSverige from "~/components/job-board/subclients/sverige/teaserbar-eon-sverige";
import { UnifiedJobPageTemplate } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import FooterEonSverige from "~/components/page-skeleton/subclients/sverige/footer-eon-sverige";
import { sverigeDefault } from "./default";

// Sverige has no map on the jobboard
function NoMap() {
  return null;
}

export const sverige = createClientConfig({
  components: {
    JobpageTemplate: UnifiedJobPageTemplate,
    Filterbar: FilterbarEonSverige,
    Joblist: JoblistEonSverige,
    HeaderImageJobboard: HeaderImageJobboardEonSverige,
    Footer: FooterEonSverige,
    TeaserBar: TeaserBarEonSverige,
    Map: NoMap,
  },
  ui: {},
  subtemplates: [sverigeDefault],
});
